import React from 'react';
import { BookOpenIcon, FileTextIcon, UtensilsCrossedIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { BRAND, HERO_BODY, HERO_EMPHASIS, HERO_HEADLINE, HERO_SUB, MAIN_MOCKUP, MOCKUP_ALT } from '../data/eatWellContent';
const INDICATORS = [{
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: ZapIcon,
  label: 'Access in 5 min'
}, {
  Icon: UtensilsCrossedIcon,
  label: '5 meal categories'
}, {
  Icon: BookOpenIcon,
  label: 'All 5 volumes'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-106" data-mp="sbb39ie0cged">
      <div className="mx-auto flex max-w-6xl flex-col px-5 pb-8 pt-6 text-center lg:grid lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-107" data-mp="s9zybf8tt2lo">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-108" data-mp="3d2l8r9xwn0zn">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-109" data-mp="382p5jcx17dl5">
            {BRAND}
          </p>
          <h1 className="mx-auto mt-3 max-w-xl font-display text-[1.6rem] font-semibold leading-tight text-ivory-50 sm:text-[2.1rem] lg:mx-0 lg:mt-4 lg:text-[2.6rem]" data-id="element-110" data-mp="3j9kazboofhg4">
            {HERO_HEADLINE}
          </h1>

          {HERO_BODY.map(line => <p key={line} className="mx-auto mt-3 max-w-lg text-[13px] leading-relaxed text-body sm:text-[15px] lg:mx-0" data-id="element-111" data-mp="39cpfz2rm3z6l">
              {line}
            </p>)}

          <p className="mx-auto mt-3 max-w-lg font-display text-[1.1rem] italic leading-snug text-champagne sm:text-2xl lg:mx-0" data-id="element-112" data-mp="358hm6r6art1i">
            {HERO_EMPHASIS}
          </p>
        </div>

        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto my-6 w-full max-w-md object-contain sm:max-w-lg lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-none" width={1536} height={1024} data-id="element-113" data-mp="2qi0nvgoylj8u" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-114" data-mp="2ljz2uq7z39uq">
          <p className="mx-auto max-w-md text-[12.5px] font-medium uppercase tracking-[0.1em] leading-snug text-ivory-200 sm:text-[13px] lg:mx-0 lg:mt-6 lg:max-w-lg" data-id="element-115" data-mp="s3351dk4moxj">
            {HERO_SUB}
          </p>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] lg:mt-4 lg:justify-start" data-id="element-116" data-mp="id9ri70fbzqn">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-117" data-mp="1ayjf37ngf433">
                <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-118" data-mp="162m137zny9th" />
                {label}
              </li>)}
          </ul>

          <div className="mt-5 flex justify-center lg:justify-start" data-id="element-119" data-mp="3lsypkqaae6eu">
            <CtaButton size="md" data-id="element-120" data-mp="3lquenodz0752" />
          </div>
          <TrustStrip className="mt-3 lg:justify-start" data-id="element-121" data-mp="3hr3sjxze2f6v" />
        </div>
      </div>
    </header>;
}